export const MASTER_WORKER_TYPE = [
    {
      name: 'independent',
      value: 'independent'
    },
    {
      name: 'dependent',
      value: 'dependent'
    }
  ];